import axios from 'axios'
import { auth, client_id, client_id_, callback } from '@/config/api'

// Axios instance
const authClient = axios.create({
  baseURL: auth,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true
})

// Get the current user profile

export async function getCurrentUser() {
  const token = localStorage.getItem('auth_token');

  if (!token) {
    throw new Error('No authentication token found');
  }

  const response = await authClient.get('/user', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  return response.data;
}

// Update user profile

export async function updateProfile(profileData) {
  const token = localStorage.getItem('auth_token');

  if (!token) {
    throw new Error('No authentication token found');
  }

  const response = await authClient.put('/user', profileData, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  return response.data;
}

// Get Google OAuth URL

export function getGoogleAuthUrl() {
  const redirectUri = encodeURIComponent(`${window.location.origin}/auth/google/callback`);
  return `${auth}/auth/google?client_id=${client_id}&redirect_uri=${redirectUri}`;
}

// Get Spotify OAuth URL

export function getSpotifyAuthUrl() {
  const redirectUri = encodeURIComponent(callback);
  return `${auth}/auth/spotify?client_id=${client_id_}&redirect_uri=${redirectUri}`;
}

// Handle OAuth callback

export async function handleOAuthCallback(provider, code) {
  const response = await authClient.post(`/auth/${provider}/callback`, { code });

  if (response.data && response.data.token) {
    localStorage.setItem('auth_token', response.data.token);
  }

  return response.data;
}

// Check if user is authenticated

export function isAuthenticated() {
  return !!localStorage.getItem('auth_token');
}

// Validate authentication with server (including IP check)

export async function validateAuthentication() {
  try {
    const token = getAuthToken()
    if (!token) {
      return false
    }

    // Make a request to validate the token and IP
    const response = await authClient.get('/user', {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })

    const data = response.data

    // If authentication failed (including IP mismatch), clear local data
    if (!data.isAuthenticated) {
      clearAuthData()
      return false
    }

    return true
  } catch (error) {
    console.error('Authentication validation failed:', error)
    clearAuthData()
    return false
  }
}

// Clear authentication data

function clearAuthData() {
  localStorage.removeItem('auth_token')
  localStorage.removeItem('user_data')
  document.cookie = 'session_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
}

// Get authentication token

export function getAuthToken() {
  return localStorage.getItem('auth_token');
}

// Logout the current user

export async function logout() {
  try {
    await authClient.post('/logout');
    localStorage.removeItem('auth_token');
  } catch (error) {
    // Still remove the token even if the API call fails
    localStorage.removeItem('auth_token');
    throw error;
  }
}
